import { mapper } from '../../tools/mapping/mapper';
import { PrelevementAir } from '../../domain/Adduction-air/prelevement-air';
import { PrelevementAirEntity } from '../entity';
import type { AppDB } from '../db';

export class PrelevementAirRepository {
    constructor(private readonly database: AppDB) {}


    async getPrelevementAirEntityByCode(code: string) {
        return await this.database.prelevementAir.where('Code').equals(code).first(async mle => {
            return mle;
        });
    }

    async getPrelevementAirById(id: number) {
        return await this.database.prelevementAir.where('Id').equals(id).first(async mle => {
            const ml = mapper.map(mle, PrelevementAirEntity, PrelevementAir);
            return ml;
        });
    }

    async attachPrelevementAir(measure: PrelevementAir, adductionId: number) {
        let paId: number;
        const pae = mapper.map(measure, PrelevementAir, PrelevementAirEntity);

        const me = await this.database.getMesureAdductionEntityById(adductionId);
        paId = await this.database.prelevementAir.add(pae);
        await this.database.measureAdduction.update(adductionId, {
            PrelevementAirIds: me?.PrelevementAirIds ? [...me.PrelevementAirIds, paId] : [paId]
        });
    }

    async clearPrelevementAirById(ids: number[]) {
        await this.database.prelevementAir.where('Id').anyOf(ids).toArray(async phe => {
            for (let i = 0; i < phe.length; i++) {
                if (phe && phe[i].Id !== undefined) {
                    await this.database.prelevementAir.where('Id').equals(phe[i].Id!).delete();
                }
            }
        })
    }
}
